import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  TextField,
  Container,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import {
  async_create_event,
  uploadEventCoverImage,
  deleteImageFile,
} from "src/actions/event.action";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import PlacesAutocomplete from "react-places-autocomplete";
import { toast } from "react-toastify";
import TicketNameField, {
  ticketNamesProblem,
  withTrimmedNames,
} from "src/components/events/TicketNameField";
import { compressedFile, COUNTRIES } from "src/utils/misc";
import Autocomplete from "@mui/material/Autocomplete";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
);

const TOKENS = {
  surface: "#FFFFFF",
  border: "#EEF0F5",
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",
  accent: "#222222",
  accentDark: "#000000",
  divider: "#F1F5F9",
};

const useStyles = makeStyles(() => ({
  root: { maxWidth: 960, margin: "0 auto", paddingTop: 24, paddingBottom: 48 },
  pageHeader: { marginBottom: 24 },
  pageTitle: { fontSize: 24, fontWeight: 700, color: TOKENS.textPrimary },
  pageSubtitle: { fontSize: 14, color: TOKENS.textSecondary, marginTop: 2 },
  section: {
    backgroundColor: TOKENS.surface,
    border: `1px solid ${TOKENS.border}`,
    borderRadius: 16,
    boxShadow: "none",
    marginBottom: 20,
    overflow: "hidden",
  },
  sectionHeader: { padding: "20px 24px 0 24px" },
  sectionTitle: { fontSize: 16, fontWeight: 600, color: TOKENS.textPrimary },
  sectionSubtitle: { fontSize: 13, color: TOKENS.textSecondary, marginTop: 2 },
  sectionContent: { padding: "16px 24px 24px 24px" },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 14,
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#A5B4FC" },
      "&.Mui-focused fieldset": { borderColor: TOKENS.accent },
    },
    "& .MuiInputLabel-root": { fontSize: 14, color: TOKENS.textSecondary },
  },
  selectField: {
    borderRadius: 8,
    fontSize: 14,
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E2E8F0" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#A5B4FC" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: TOKENS.accent,
    },
  },
  ticketRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 14px",
    backgroundColor: "#FAFBFC",
    borderRadius: 10,
    border: `1px solid ${TOKENS.border}`,
    marginBottom: 8,
  },
  addRowBtn: {
    color: TOKENS.accent,
    borderColor: TOKENS.border,
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": { borderColor: "#A5B4FC", backgroundColor: "#EEF2FF" },
  },
  pondWrapper: {
    "& .filepond--root": { fontFamily: "inherit" },
    "& .filepond--panel-root": {
      backgroundColor: "#FAFBFC",
      borderRadius: 12,
      border: `2px dashed ${TOKENS.border}`,
    },
    "& .filepond--drop-label": { color: TOKENS.textSecondary, fontSize: 14 },
    "& .filepond--label-action": {
      color: TOKENS.accent,
      fontWeight: 600,
      textDecorationColor: TOKENS.accent,
    },
    "& .filepond--item-panel": { borderRadius: 10 },
    "& .filepond--image-preview-wrapper": { borderRadius: 10 },
  },
  hint: { fontSize: 12, color: TOKENS.textMuted, marginTop: 8 },
  submitButton: {
    backgroundColor: TOKENS.accent,
    color: "#FFFFFF",
    borderRadius: 8,
    padding: "12px 32px",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 1px 2px rgba(34, 34, 34, 0.3)",
    "&:hover": { backgroundColor: TOKENS.accentDark },
    "&:disabled": { backgroundColor: "#C7D2FE", color: "#FFFFFF" },
  },
  locationSuggestion: {
    display: "flex",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    borderRadius: 8,
    marginTop: 4,
  },
}));

function CreateEvent({
  async_create_event,
  uploadEventCoverImage,
  deleteImageFile,
}) {
  const classes = useStyles();
  const navigate = useNavigate();

  const [address, setAddress] = React.useState("");
  const [country, setCountry] = React.useState("Uganda");
  const [cover, setCover] = React.useState([]);
  const [coverFile, setCoverFile] = React.useState(
    "https://tubayo.s3.us-west-2.amazonaws.com/tubayo-img-1729514068387.png",
  );
  const [tickets, setTickets] = React.useState([
    { ticket_name: "", price_rate: "", ticket_price: "" },
  ]);

  const handleTicketChange = (i, e) => {
    const { name, value } = e.target;
    setTickets(tickets.map((t, idx) => (idx === i ? { ...t, [name]: value } : t)));
  };

  return (
    <Container className={classes.root}>
      <Box className={classes.pageHeader}>
        <Typography className={classes.pageTitle}>Create Event</Typography>
        <Typography className={classes.pageSubtitle}>
          Add event details, schedule, tickets, and cover image
        </Typography>
      </Box>

      <Formik
        initialValues={{
          event_name: "",
          summary: "",
          start_date: "",
          start_time: "10:00",
          end_date: "",
          end_time: "10:00",
          full_description: "",
          district: "",
          extra_information: "",
        }}
        validationSchema={Yup.object().shape({
          event_name: Yup.string().required("Required"),
          summary: Yup.string().required("Required").max(50),
          full_description: Yup.string().required("Required").max(200),
          start_date: Yup.date().required("Required"),
          end_date: Yup.date().required("Required"),
          start_time: Yup.string().required("Required"),
          end_time: Yup.string().required("Required"),
          district: Yup.string().required("Required"),
          extra_information: Yup.string().required("Required"),
        })}
        onSubmit={async (values) => {
          const ticketProblem = ticketNamesProblem(tickets);
          if (ticketProblem) return toast.warning(ticketProblem);
          if (!coverFile) return toast.warning("Please add a cover image!");
          const obj = {
            ...values,
            cover_image_url: coverFile,
            address,
            tickets: withTrimmedNames(tickets),
            country,
          };
          await async_create_event(obj, navigate);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
        }) => (
          <form onSubmit={handleSubmit}>
            {/* Basic Info */}
            <Card className={classes.section}>
              <Box className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  Basic Information
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Event name and location
                </Typography>
              </Box>
              <CardContent className={classes.sectionContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.event_name && errors.event_name)}
                      helperText={touched.event_name && errors.event_name}
                      variant="outlined"
                      required
                      fullWidth
                      label="Event Name"
                      name="event_name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      disableClearable
                      fullWidth
                      options={COUNTRIES}
                      onChange={(_, v) => setCountry(v)}
                      inputValue={country}
                      onInputChange={(_, v) => setCountry(v)}
                      getOptionLabel={(o) => o}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className={classes.textField}
                          variant="outlined"
                          label="Country"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.district && errors.district)}
                      helperText={touched.district && errors.district}
                      variant="outlined"
                      required
                      fullWidth
                      label="District / City"
                      name="district"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <PlacesAutocomplete
                      value={address}
                      onChange={setAddress}
                      onSelect={setAddress}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <TextField
                            {...getInputProps({
                              variant: "outlined",
                              label: "Google Maps Address",
                              placeholder: "Search address",
                              fullWidth: true,
                              className: classes.textField,
                            })}
                          />
                          {(loading || suggestions.length > 0) && (
                            <Box
                              style={{
                                border: "1px solid #E2E8F0",
                                borderRadius: 8,
                                marginTop: 4,
                                overflow: "hidden",
                              }}
                            >
                              {loading && (
                                <Box style={{ padding: 12 }}>
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    Searching...
                                  </Typography>
                                </Box>
                              )}
                              {suggestions.map((s) => (
                                <div
                                  {...getSuggestionItemProps(s, {
                                    className: classes.locationSuggestion,
                                    style: {
                                      backgroundColor: s.active
                                        ? "#F1F5F9"
                                        : "#FFFFFF",
                                    },
                                  })}
                                >
                                  <LocationCityIcon
                                    style={{
                                      marginRight: 10,
                                      color: TOKENS.textMuted,
                                      fontSize: 18,
                                    }}
                                  />
                                  <Typography
                                    variant="body2"
                                    style={{ fontSize: 13 }}
                                  >
                                    {s.description}
                                  </Typography>
                                </div>
                              ))}
                            </Box>
                          )}
                        </div>
                      )}
                    </PlacesAutocomplete>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Schedule */}
            <Card className={classes.section}>
              <Box className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  Schedule
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  When does the event start and end?
                </Typography>
              </Box>
              <CardContent className={classes.sectionContent}>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={3}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.start_date && errors.start_date)}
                      helperText={touched.start_date && errors.start_date}
                      variant="outlined"
                      required
                      fullWidth
                      label="Start Date"
                      name="start_date"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.start_time && errors.start_time)}
                      helperText={touched.start_time && errors.start_time}
                      variant="outlined"
                      required
                      fullWidth
                      label="Start Time"
                      name="start_time"
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.end_date && errors.end_date)}
                      helperText={touched.end_date && errors.end_date}
                      variant="outlined"
                      required
                      fullWidth
                      label="End Date"
                      name="end_date"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.end_time && errors.end_time)}
                      helperText={touched.end_time && errors.end_time}
                      variant="outlined"
                      required
                      fullWidth
                      label="End Time"
                      name="end_time"
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Description */}
            <Card className={classes.section}>
              <Box className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  Description
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Tell guests about the event
                </Typography>
              </Box>
              <CardContent className={classes.sectionContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(touched.summary && errors.summary)}
                      helperText={touched.summary && errors.summary}
                      variant="outlined"
                      required
                      fullWidth
                      label="Brief Summary"
                      name="summary"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Max 50 characters"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(
                        touched.full_description && errors.full_description,
                      )}
                      helperText={
                        touched.full_description && errors.full_description
                      }
                      variant="outlined"
                      required
                      fullWidth
                      multiline
                      minRows={3}
                      label="Full Description"
                      name="full_description"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.textField}
                      error={Boolean(
                        touched.extra_information && errors.extra_information,
                      )}
                      helperText={
                        touched.extra_information && errors.extra_information
                      }
                      variant="outlined"
                      required
                      fullWidth
                      label="Extra Information"
                      name="extra_information"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Restrictions, dress code, etc."
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Tickets */}
            <Card className={classes.section}>
              <Box className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  Ticket Categories
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Set pricing tiers for your event
                </Typography>
              </Box>
              <CardContent className={classes.sectionContent}>
                {tickets.map((ticket, idx) => (
                  <Box key={idx} className={classes.ticketRow}>
                    <TicketNameField
                      value={ticket.ticket_name}
                      onChange={(name) =>
                        handleTicketChange(idx, {
                          target: { name: "ticket_name", value: name },
                        })
                      }
                      takenNames={tickets
                        .filter((_, i) => i !== idx)
                        .map((t) => t.ticket_name)}
                      className={classes.textField}
                    />
                    <TextField
                      className={classes.textField}
                      variant="outlined"
                      label="Rate"
                      name="price_rate"
                      value={ticket.price_rate}
                      onChange={(e) => handleTicketChange(idx, e)}
                      placeholder="Per person"
                      style={{ flex: 1 }}
                    />
                    <TextField
                      className={classes.textField}
                      variant="outlined"
                      label="Price (USD)"
                      name="ticket_price"
                      value={ticket.ticket_price}
                      onChange={(e) => handleTicketChange(idx, e)}
                      type="number"
                      inputProps={{ min: 0 }}
                      style={{ width: 130 }}
                    />
                    {tickets.length > 1 && (
                      <IconButton
                        size="small"
                        style={{ color: "#EF4444" }}
                        onClick={() =>
                          setTickets(tickets.filter((_, i) => i !== idx))
                        }
                      >
                        <RemoveIcon style={{ fontSize: 18 }} />
                      </IconButton>
                    )}
                  </Box>
                ))}
                {tickets.length < 4 && (
                  <Button
                    variant="outlined"
                    className={classes.addRowBtn}
                    startIcon={<AddIcon style={{ fontSize: 16 }} />}
                    onClick={() =>
                      setTickets([
                        ...tickets,
                        { ticket_name: "", price_rate: "", ticket_price: "" },
                      ])
                    }
                  >
                    Add Ticket Tier
                  </Button>
                )}
              </CardContent>
            </Card>

            {/* Cover Image */}
            <Card className={classes.section}>
              <Box className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  Cover Image
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Upload a cover image for your event
                </Typography>
              </Box>
              <CardContent className={classes.sectionContent}>
                <Box className={classes.pondWrapper}>
                  <FilePond
                    files={cover}
                    onupdatefiles={setCover}
                    allowMultiple={false}
                    allowImageResize={true}
                    allowRemove={true}
                    acceptedFileTypes={["image/*"]}
                    server={{
                      process: async (
                        fieldName,
                        file,
                        metadata,
                        load,
                        error,
                        progress,
                        abort,
                      ) => {
                        try {
                          const image = await compressedFile(file);
                          const formData = new FormData();
                          formData.append("file", image);
                          const res = await uploadEventCoverImage(formData);
                          setCoverFile(res);
                          load();
                        } catch (err) {
                          error("Upload failed");
                        }
                        return { abort: () => abort() };
                      },
                      revert: async (uid, load) => {
                        try {
                          const keyObject = { Key: coverFile.Key };
                          await deleteImageFile(keyObject);
                          setCoverFile({});
                          load();
                        } catch {
                          load();
                        }
                      },
                    }}
                    labelIdle='Drag & drop image or <span class="filepond--label-action">Browse</span>'
                  />
                </Box>
                <Typography className={classes.hint}>
                  Max 2 MB. JPG, PNG, or WebP.
                </Typography>
              </CardContent>
            </Card>

            <Box
              display="flex"
              justifyContent="flex-end"
              style={{ marginTop: 8 }}
            >
              <Button
                type="submit"
                disabled={isSubmitting}
                variant="contained"
                className={classes.submitButton}
                endIcon={<ArrowForwardIcon />}
              >
                Create Event
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Container>
  );
}

export default connect(null, {
  async_create_event,
  uploadEventCoverImage,
  deleteImageFile,
})(CreateEvent);
